var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRulerFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1343_7305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.92901 13.207L7.05001 15.328L8.46401 13.914L6.34401 11.793L8.46401 9.67201L11.293 12.5L12.707 11.086L9.88001 8.25701L12 6.13601L14.121 8.25701L15.536 6.84301L13.414 4.72201L16.243 1.89301C16.4305 1.70554 16.6848 1.60022 16.95 1.60022C17.2152 1.60022 17.4695 1.70554 17.657 1.89301L22.607 6.84301C22.7945 7.03053 22.8998 7.28484 22.8998 7.55001C22.8998 7.81517 22.7945 8.06948 22.607 8.25701L7.75701 23.107C7.56948 23.2945 7.31517 23.3998 7.05001 23.3998C6.78484 23.3998 6.53053 23.2945 6.34301 23.107L1.39301 18.157C1.20554 17.9695 1.10022 17.7152 1.10022 17.45C1.10022 17.1848 1.20554 16.9305 1.39301 16.743L4.92901 13.207Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1343_7305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRulerFill);
export default __webpack_public_path__ + "static/media/ruler-fill.4ab7ee994806ff065afd5eaa00c28763.svg";
export { ForwardRef as ReactComponent };